import { CdkCell, CdkCellDef, CdkColumnDef, CdkHeaderCell, CdkHeaderCellDef } from '@angular/cdk/table';
import { Component, Inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    BaseTableModule,
    DefaultTooltipComponent,
    SelectableRow,
    TextTableHeaderComponent,
    TooltipDirective,
    WINDOW,
} from '@os-components';
import { SewButton, SewHeadline } from '@sew/ui-components-angular/standalone';
import { PartTableSkeletonComponent } from '../../../../../components/part-table-skeleton/part-table-skeleton.component';
import { OrderNumberItem } from './order-number-table.interface';

@Component({
    selector: 'ecs-order-number-table',
    templateUrl: './order-number-table.component.html',
    styleUrls: ['./order-number-table.component.scss'],
    imports: [
        SewHeadline,
        SewButton,
        BaseTableModule,
        CdkColumnDef,
        CdkHeaderCellDef,
        CdkHeaderCell,
        CdkCellDef,
        CdkCell,
        TooltipDirective,
        PartTableSkeletonComponent,
        TranslatePipe,
        TextTableHeaderComponent,
        DefaultTooltipComponent,
    ],
})
export class OrderNumberTableComponent {
    @Input() public orderNumber?: string;

    @Input() public set items(items: OrderNumberItem[] | undefined | null) {
        if (!items) {
            return;
        }

        this.rows = this.generateRows(items);
    }

    public rows: SelectableRow<OrderNumberItem>[] = [];

    public constructor(@Inject(WINDOW) private window: Window) {}

    public openSearchInNewTab(searchTerm: string) {
        if (!searchTerm || searchTerm.length === 0) {
            return;
        }

        const newTab = this.window.open(`?SEARCH_STRING=${searchTerm}`, '_blank');
        if (newTab) {
            newTab.focus();
        }
    }

    private generateRows(items: OrderNumberItem[]) {
        return items.reduce(
            (rows, currentRow) => [
                ...rows,
                { isSelectableRow: true, isDisabled: !currentRow.id, rowData: currentRow },
            ],
            [] as SelectableRow<OrderNumberItem>[]
        );
    }
}
